<template>
  <q-page id="negocios" class="neg-escopo">
    <div class="q-pa-md">
      <sem-permissao v-if="bloqueado" />

      <div v-else class="neg-tela">
      <q-tabs
        v-model="aba"
        dense
        no-caps
        align="left"
        active-color="primary"
        indicator-color="primary"
        class="neg-abas"
      >
        <q-tab name="funil" label="Funil" />
        <q-tab v-if="podeVerComissaoNegocios" name="comissoes" label="Comissões" />
        <q-tab v-if="podeVerProducaoNegocios" name="producao" label="Produção" />
      </q-tabs>

      <div class="neg-cabecalho">
        <q-btn
          v-if="podeAdicionarNegocios"
          flat
          round
          dense
          icon="add"
          color="primary"
          style="margin-right: 10px; margin-left: 0"
          :class="{ 'neg-cabecalho__acao--oculta': aba !== 'funil' }"
          @click="abrirNova"
        >
          <q-tooltip>Nova oportunidade</q-tooltip>
        </q-btn>
        <div>
          <div class="q-table__title">Negócios</div>
          <div class="neg-sub">{{ contexto }}</div>
        </div>
        <q-space />
      </div>

      <template v-if="aba === 'funil'">
        <negocios-filtros
          @mudou="recarregar"
          @limpar="limparFiltros"
          @alternar-view="alternarView"
        />

        <div v-if="negociosCarregando" class="text-center q-pa-lg">
          <q-spinner color="blue-7" size="3em" />
        </div>

        <template v-else>
          <negocios-quadro
            v-if="viewEfetiva === 'quadro'"
            @abrir="abrirDetalhe"
            @mover="pedirMovimento"
            @ver-lista="verNaLista"
          />
          <negocios-lista v-else @abrir="abrirDetalhe" @ordenar="ordenar" />
        </template>
      </template>

      <negocios-comissoes v-else-if="aba === 'comissoes'" ref="comissoes" @receber="abrirBaixa" />

      <negocios-producao v-else-if="aba === 'producao'" />
      </div>
    </div>

    <q-page-sticky v-if="podeConfigurarNegocios && !drawerAberto" position="top-right" :offset="[0, 90]">
      <q-btn
        :color="drawerOpcoes ? 'red-7' : 'blue-7'"
        :icon="drawerOpcoes ? 'close' : 'settings'"
        class="rotate-0"
        style="border-top-left-radius: 50px;border-bottom-left-radius: 50px"
        @click="alternarOpcoes"
      >
        <q-tooltip
          :class="drawerOpcoes ? 'bg-negative text-white text-center' : 'bg-secondary text-white text-center'"
        >{{ drawerOpcoes ? "Fechar Opções Avançadas" : "Opções Avançadas" }}</q-tooltip>
      </q-btn>
    </q-page-sticky>

    <q-drawer
      v-if="!drawerAberto"
      side="right"
      v-model="drawerOpcoes"
      bordered
      :width="300"
      :breakpoint="500"
      behavior="default"
      class="bg-white"
    >
      <q-scroll-area class="fit">
        <div class="q-pa-sm">
          <div class="q-table__title">Opções Avançadas</div>
          <div>
            <q-list class="rounded-borders" style="max-width: 350px; margin-left: -10px;width: 300px;">
              <q-item-label header></q-item-label>

              <q-item
                v-if="temPermissaoNegocios('Negocios.etapas')"
                clickable
                v-ripple
                @click="abrirOpcao('modalEtapas')"
              >
                <q-item-section>
                  <q-item-label lines="1">Etapas do quadro</q-item-label>
                  <q-item-label caption>Nome, ordem, cor e prazo de retorno de cada etapa</q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                v-if="temPermissaoNegocios('Negocios.linhas')"
                clickable
                v-ripple
                @click="abrirOpcao('modalLinhas')"
              >
                <q-item-section>
                  <q-item-label lines="1">Linhas de crédito</q-item-label>
                  <q-item-label caption>Produtos oferecidos e o percentual de comissão de cada um</q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                v-if="temPermissaoNegocios('Negocios.config')"
                clickable
                v-ripple
                @click="abrirOpcao('modalConfig')"
              >
                <q-item-section>
                  <q-item-label lines="1">Configurações do módulo</q-item-label>
                  <q-item-label caption>Dia do repasse e a receita gerada na baixa da comissão</q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                v-if="temPermissaoNegocios('Negocios.reatribuirCarteira')"
                clickable
                v-ripple
                @click="abrirOpcao('modalReatribuicao')"
              >
                <q-item-section>
                  <q-item-label lines="1">Reatribuir carteira</q-item-label>
                  <q-item-label caption>Transfere as propostas abertas de um Operador para outro</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </div>
      </q-scroll-area>
    </q-drawer>

    <negocios-drawer-oportunidade
      v-if="!drawerOpcoes"
      v-model="drawerAberto"
      @mover="moverPeloDetalhe"
      @editar="abrirEdicao"
      @excluir="confirmarExclusao"
      @receber="abrirBaixaDaOportunidade"
      @alterar-data="modalData = true"
      @editar-recebimento="abrirRecebimento"
      @emitir-nota-fiscal="emitirNotaFiscal"
      @marcar-checklist="marcarChecklist"
    />

    <negocios-modal-oportunidade
      v-model="modalOportunidade"
      :oportunidade="emEdicao"
      @salvou="aposSalvar"
    />

    <negocios-modal-motivo
      v-model="modalMotivo"
      :origem="movimento.origem"
      :destino="movimento.destino"
      @confirmar="confirmarReabertura"
    />

    <negocios-modal-data-alerta
      v-model="modalData"
      :data-atual="dataAlertaAtual"
      @confirmar="salvarDataAlerta"
    />

    <negocios-modal-etapas v-model="modalEtapas" @mudou="recarregar" />
    <negocios-modal-linhas v-model="modalLinhas" />
    <negocios-modal-configuracao v-model="modalConfig" />
    <negocios-modal-reatribuicao v-model="modalReatribuicao" @transferiu="recarregar" />

    <negocios-modal-baixa v-model="modalBaixa" :itens="itensDaBaixa" @registrou="aposBaixa" />

    <negocios-modal-recebimento
      v-model="modalRecebimento"
      :recebimento="recebimentoEmEdicao"
      @mudou="aposBaixa"
    />

    <q-dialog v-model="modalExclusao" persistent>
      <q-card class="neg-escopo neg-modal">
        <q-card-section class="neg-modal__titulo">Excluir oportunidade</q-card-section>
        <q-card-section>
          A oportunidade {{ oportunidadeParaExcluir ? oportunidadeParaExcluir.codigo : "" }} sai do quadro e não volta. Confirma?
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat no-caps label="Cancelar" @click="modalExclusao = false" />
          <q-btn flat no-caps color="negative" label="Excluir" @click="excluirConfirmado" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin, { PERMISSOES_NEGOCIOS } from "@/mixins/negocios";

export default {
  name: "negocios",
  mixins: [negociosMixin],
  data() {
    return {
      aba: "funil",
      moduloCarregado: false,
      drawerAberto: false,
      drawerOpcoes: false,
      emEdicao: null,
      recebimentoEmEdicao: null,
      itensDaBaixa: [],
      oportunidadeParaExcluir: null,
      movimento: { oportunidade: null, origem: null, destino: null }
    };
  },
  computed: {
    ...mapGetters([
      "negociosView",
      "negociosCarregando",
      "negociosSemPermissao",
      "negociosOportunidade",
      "negociosEtapas",
      "OpenDialogNegociosOportunidade",
      "OpenDialogNegociosMotivo",
      "OpenDialogNegociosData",
      "OpenDialogNegociosEtapas",
      "OpenDialogNegociosLinhas",
      "OpenDialogNegociosConfig",
      "OpenDialogNegociosReatribuicao",
      "OpenDialogNegociosBaixa",
      "OpenDialogNegociosRecebimento",
      "OpenDialogNegociosExclusao"
    ]),
    modalOportunidade: {
      get() {
        return this.OpenDialogNegociosOportunidade;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosOportunidade", valor);
      }
    },
    modalMotivo: {
      get() {
        return this.OpenDialogNegociosMotivo;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosMotivo", valor);
      }
    },
    modalData: {
      get() {
        return this.OpenDialogNegociosData;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosData", valor);
      }
    },
    modalEtapas: {
      get() {
        return this.OpenDialogNegociosEtapas;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosEtapas", valor);
      }
    },
    modalLinhas: {
      get() {
        return this.OpenDialogNegociosLinhas;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosLinhas", valor);
      }
    },
    modalConfig: {
      get() {
        return this.OpenDialogNegociosConfig;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosConfig", valor);
      }
    },
    modalReatribuicao: {
      get() {
        return this.OpenDialogNegociosReatribuicao;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosReatribuicao", valor);
      }
    },
    modalBaixa: {
      get() {
        return this.OpenDialogNegociosBaixa;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosBaixa", valor);
      }
    },
    modalRecebimento: {
      get() {
        return this.OpenDialogNegociosRecebimento;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosRecebimento", valor);
      }
    },
    modalExclusao: {
      get() {
        return this.OpenDialogNegociosExclusao;
      },
      set(valor) {
        this.$store.commit("OpenDialogNegociosExclusao", valor);
      }
    },
    bloqueado() {
      return this.negociosSemPermissao || !this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.listar);
    },
    viewEfetiva() {
      return this.negociosView;
    },
    contexto() {
      if (this.aba === "comissoes") {
        return "Previsto contra recebido, e a baixa do repasse do banco";
      }

      if (this.aba === "producao") {
        return "Abertas, contratadas e comissão por Operador no período";
      }

      if (this.viewEfetiva !== "quadro") {
        return "Clique na linha para abrir o detalhe";
      }

      return this.telaEstreita
        ? "Toque no card para abrir e mover pelo detalhe"
        : "Arraste o card para mudar a etapa";
    },
    dataAlertaAtual() {
      return this.negociosOportunidade ? this.negociosOportunidade.data_alerta : null;
    }
  },
  watch: {
    bloqueado(valor) {
      if (!valor) {
        this.carregarModulo();
      }
    },
    aba(valor) {
      if (valor === "comissoes") {
        this.$store.dispatch("carregarNegociosComissoes");
      }

      if (valor === "producao") {
        this.$store.dispatch("carregarNegociosProducao");
      }
    }
  },
  created() {
    this.carregarModulo();
  },
  methods: {
    carregarModulo() {
      if (this.bloqueado || this.moduloCarregado) {
        return;
      }

      this.moduloCarregado = true;

      this.$store.dispatch("carregarNegociosEtapas");
      this.$store.dispatch("carregarNegociosLinhas", true);
      this.$store.dispatch("carregarNegociosFuncionarios");
      this.$store.dispatch("carregarNegociosConfig");

      this.recarregar();
    },
    alternarOpcoes() {
      this.drawerAberto = false;
      this.drawerOpcoes = !this.drawerOpcoes;
    },
    abrirOpcao(modal) {
      this.drawerOpcoes = false;
      this[modal] = true;
    },
    recarregar() {
      return this.$store.dispatch("carregarNegociosFunil");
    },
    limparFiltros() {
      return this.$store.dispatch("limparNegociosFiltros");
    },
    alternarView() {
      this.$store.commit("negociosView", this.negociosView === "quadro" ? "lista" : "quadro");
      this.recarregar();
    },
    verNaLista(etapaId) {
      this.$store.commit("negociosFiltros", { etapa_id: etapaId });
      this.$store.commit("negociosView", "lista");
      this.recarregar();
    },
    ordenar(pedido) {
      this.$store.commit("negociosOrdem", { sort: pedido.sort, direction: pedido.direction });
      this.$store.commit("negociosPaging", {
        ...this.$store.getters.negociosPaging,
        page: pedido.page,
        limit: pedido.limit
      });
      this.recarregar();
    },
    abrirNova() {
      this.emEdicao = null;
      this.modalOportunidade = true;
    },
    abrirEdicao() {
      this.emEdicao = this.negociosOportunidade;
      this.modalOportunidade = true;
    },
    abrirDetalhe(oportunidade) {
      this.$store.dispatch("abrirNegociosOportunidade", oportunidade.id).then(resposta => {
        if (!resposta.success) {
          this.avisar(resposta.message, "orange");
          return;
        }

        this.drawerOpcoes = false;
        this.drawerAberto = true;
      });
    },
    aposSalvar(oportunidade) {
      this.emEdicao = null;
      this.recarregar();

      if (this.drawerAberto && oportunidade) {
        this.$store.commit("negociosOportunidade", oportunidade);
      }
    },
    etapaDe(oportunidade) {
      return this.negociosEtapas.find(etapa => etapa.id === oportunidade.etapa_id) || null;
    },
    pedirMovimento({ oportunidade, etapa }) {
      const origem = this.etapaDe(oportunidade);

      this.movimento = { oportunidade, origem, destino: etapa };

      if (!origem || !origem.encerra || origem.id === etapa.id) {
        return this.executarMovimento(null);
      }

      if (!this.podeReabrirNegocios) {
        this.avisar(
          "Esta oportunidade está encerrada. Só quem tem permissão para reabrir pode tirá-la desta etapa.",
          "orange"
        );
        return;
      }

      this.modalMotivo = true;
    },
    confirmarReabertura(motivo) {
      this.modalMotivo = false;
      this.executarMovimento(motivo);
    },
    executarMovimento(motivo) {
      const { oportunidade, origem, destino } = this.movimento;
      const noQuadro = this.viewEfetiva === "quadro" && this.aba === "funil";

      if (noQuadro) {
        this.$store.commit("negociosCartaMovida", {
          oportunidadeId: oportunidade.id,
          etapaId: destino.id
        });
      }

      this.$store
        .dispatch("moverNegociosOportunidade", {
          id: oportunidade.id,
          etapaId: destino.id,
          motivo
        })
        .then(resposta => {
          if (!resposta.success) {
            if (noQuadro && origem) {
              this.$store.commit("negociosCartaMovida", {
                oportunidadeId: oportunidade.id,
                etapaId: origem.id
              });
            }

            this.avisar(resposta.message, "orange");
            return;
          }

          if (this.drawerAberto) {
            this.$store.commit("negociosOportunidade", resposta.oportunidade);
          }

          if (!noQuadro) {
            this.recarregar();
          }

          this.avisarMovimento(resposta.oportunidade);
        });
    },
    avisarMovimento(oportunidade) {
      const data = oportunidade.data_alerta;
      const mensagem = data
        ? "Movida. Retorno em " + this.dataParaTela(data)
        : "Movida. Esta etapa não tem prazo de retorno";

      this.$q.notify({
        message: mensagem,
        color: "green",
        position: "top-right",
        actions: [
          {
            label: "Alterar data",
            color: "white",
            handler: () => {
              this.$store.commit("negociosOportunidade", oportunidade);
              this.modalData = true;
            }
          }
        ]
      });
    },
    moverPeloDetalhe(etapa) {
      this.pedirMovimento({ oportunidade: this.negociosOportunidade, etapa });
    },
    salvarDataAlerta(data) {
      const oportunidade = this.negociosOportunidade;

      this.$store
        .dispatch("salvarNegociosOportunidade", {
          id: oportunidade.id,
          dados: { data_alerta: data }
        })
        .then(resposta => {
          this.modalData = false;
          this.avisar(resposta.message, resposta.success ? "green" : "orange");

          if (resposta.success) {
            this.$store.commit("negociosOportunidade", resposta.oportunidade);
            this.recarregar();
          }
        });
    },
    confirmarExclusao() {
      this.oportunidadeParaExcluir = this.negociosOportunidade;
      this.modalExclusao = true;
    },
    excluirConfirmado() {
      const oportunidade = this.oportunidadeParaExcluir;

      this.modalExclusao = false;

      if (!oportunidade) {
        return;
      }

      this.$store.dispatch("excluirNegociosOportunidade", oportunidade.id).then(resposta => {
        this.avisar(resposta.message, resposta.success ? "green" : "orange");

        if (resposta.success) {
          this.drawerAberto = false;
          this.recarregar();
        }
      });
    },
    abrirBaixa(selecionadas) {
      this.itensDaBaixa = selecionadas;
      this.modalBaixa = true;
    },
    abrirBaixaDaOportunidade() {
      const oportunidade = this.negociosOportunidade;

      this.itensDaBaixa = [
        {
          oportunidade_id: oportunidade.id,
          codigo: oportunidade.codigo,
          cliente: oportunidade.cliente ? oportunidade.cliente.nome : "",
          comissao_prevista: oportunidade.comissao_prevista,
          comissao_recebida: oportunidade.comissao_recebida
        }
      ];
      this.modalBaixa = true;
    },
    abrirRecebimento(recebimento) {
      this.recebimentoEmEdicao = recebimento;
      this.modalRecebimento = true;
    },
    emitirNotaFiscal(recebimento) {
      this.$store.dispatch("emitirNegociosNotaFiscal", [recebimento.id]).then(resposta => {
        this.avisar(resposta.message, resposta.success ? "green" : "orange");

        if (resposta.success && this.negociosOportunidade) {
          this.$store.dispatch("abrirNegociosOportunidade", this.negociosOportunidade.id);
        }
      });
    },
    marcarChecklist({ item, marcado }) {
      const oportunidadeId = this.negociosOportunidade.id;

      this.$store
        .dispatch("marcarNegociosChecklistItem", { oportunidadeId, item, marcado })
        .then(resposta => {
          if (!resposta.success) {
            this.avisar(resposta.message, "orange");
          }
        });
    },
    aposBaixa() {
      if (this.$refs.comissoes) {
        this.$refs.comissoes.limparSelecao();
      }

      this.$store.dispatch("carregarNegociosComissoes");
      this.recarregar();

      if (this.negociosOportunidade) {
        this.$store.dispatch("abrirNegociosOportunidade", this.negociosOportunidade.id);
      }
    }
  }
};
</script>

<style lang="stylus">
.neg-escopo
  --neg-azul #2741b5
  --neg-azul-c #dde1ff
  --neg-azul-e #00164e
  --neg-verde #337c24
  --neg-verde-c #c8f0bb
  --neg-verde-e #0b2b04
  --neg-ambar #f9b500
  --neg-ambar-c #ffe9b0
  --neg-ambar-e #4a3300
  --neg-verm #a22a13
  --neg-verm-c #ffdad3
  --neg-verm-e #3d0900
  --neg-bg #f7f5fd
  --neg-sup #ffffff
  --neg-sup1 #f2f0fa
  --neg-sup2 #eae8f4
  --neg-txt #1b1b21
  --neg-txt2 #46464f
  --neg-linha #c9c7d2
  --neg-borda #767680

#negocios.neg-escopo
  color var(--neg-txt)

.neg-escopo
  .neg-tela
    display flex
    flex-direction column
    gap 12px

  .neg-abas
    color var(--neg-txt2)

  .neg-cabecalho
    display flex
    align-items center
    gap 12px

  .neg-cabecalho__acao--oculta
    visibility hidden

  .neg-sub
    font-size 13px
    color var(--neg-txt2)

  .neg-filtros
    display flex
    flex-direction column
    gap 10px

  .neg-busca
    min-width 260px
    background var(--neg-sup)

  .neg-painel
    display grid
    grid-template-columns repeat(auto-fit, minmax(190px, 1fr))
    gap 14px
    background var(--neg-sup)
    border-radius 24px
    padding 18px 20px

  .neg-aviso
    display flex
    align-items center
    gap 8px
    background var(--neg-ambar-c)
    color var(--neg-ambar-e)
    border-radius 999px
    padding 6px 14px
    font-size 12.5px
    margin-bottom 10px

  .neg-quadro__titulo-movel
    display flex
    align-items baseline
    justify-content space-between
    gap 8px
    padding 0 2px 8px
    font-size 15px
    font-weight 500

  .neg-quadro__etapa-posicao
    color var(--neg-txt2)
    font-weight 400
    font-size 12.5px
    white-space nowrap

  .neg-board
    display flex
    gap 16px
    overflow-x auto
    padding-bottom 6px
    align-items stretch

  .neg-board--movel
    gap 0
    scroll-snap-type x mandatory
    -webkit-overflow-scrolling touch

  .neg-coluna
    background var(--neg-sup1)
    border-radius 24px
    width 288px
    flex none
    display flex
    flex-direction column
    overflow hidden
    padding-bottom 12px

  .neg-coluna--movel
    width 100%
    scroll-snap-align start

  .neg-coluna--alvo
    background var(--neg-sup2)
    outline 2px dashed var(--neg-azul)
    outline-offset -4px

  .neg-coluna__faixa
    height 3px
    width 100%
    flex none

  .neg-coluna__topo
    display flex
    align-items center
    gap 9px
    padding 14px 16px 0

  .neg-coluna__final
    color var(--neg-txt2)

  .neg-coluna__nome
    font-size 15px
    font-weight 500
    flex 1
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

  .neg-coluna__qtd
    background var(--neg-sup2)
    color var(--neg-txt2)
    font-size 12.5px
    font-weight 500
    border-radius 999px
    padding 3px 11px

  .neg-coluna__total
    font-size 13.5px
    color var(--neg-txt2)
    padding 2px 16px 12px

  .neg-coluna__trunc
    background var(--neg-sup2)
    margin 0 14px 11px
    border-radius 14px
    padding 9px 12px
    font-size 12.5px
    color var(--neg-txt2)
    display flex
    align-items center
    justify-content space-between
    gap 8px

  .neg-link
    color var(--neg-azul-e)
    font-weight 500
    cursor pointer
    white-space nowrap

  .neg-coluna__cards
    display flex
    flex-direction column
    gap 11px
    padding 0 14px 4px
    overflow-y auto
    flex 1
    min-height 120px

  .neg-card
    background var(--neg-sup)
    border-radius 18px
    padding 12px 15px
    border-left 4px solid var(--neg-verde)
    height 148px
    overflow hidden
    cursor pointer
    flex none

  .neg-card--amarelo
    border-left-color var(--neg-ambar)

  .neg-card--vermelho
    border-left-color var(--neg-verm)

  .neg-card__topo
    display flex
    align-items center
    justify-content space-between
    gap 8px
    margin-bottom 6px

  .neg-card__codigo
    font-size 12px
    color var(--neg-txt2)
    font-family monospace

  .neg-card__nome
    font-size 15px
    font-weight 500
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

  .neg-card__linha
    font-size 12.5px
    color var(--neg-txt2)
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

  .neg-card__rodape
    display flex
    align-items baseline
    justify-content space-between
    gap 8px
    margin-top 8px

  .neg-card__valor
    font-size 15px
    font-weight 500

  .neg-card__dias
    font-size 12.5px
    color var(--neg-txt2)
    white-space nowrap

  .neg-card__checklist
    display flex
    align-items center
    gap 5px
    margin-top 7px
    font-size 12px
    color var(--neg-txt2)

  .neg-card__checklist--completo
    color var(--neg-verde)

  .neg-vazio
    text-align center
    padding 30px 10px
    color var(--neg-txt2)
    font-size 14px

  .neg-vazio--board
    padding 60px 10px
    background var(--neg-sup1)
    border 1px dashed var(--neg-linha)
    border-radius 8px

  .neg-badge
    display inline-flex
    align-items center
    padding 4px 12px
    border-radius 999px
    font-size 12px
    font-weight 500
    white-space nowrap

  .neg-oculto
    color var(--neg-txt2)
    letter-spacing 1px

  .neg-negativo
    color var(--neg-verm)

  .neg-alerta--vermelho
    color var(--neg-verm)
    font-weight 500

  .neg-alerta--amarelo
    color var(--neg-ambar-e)
    font-weight 500

  .neg-tabela
    background var(--neg-sup)
    border-radius 24px

  .neg-totais
    display grid
    grid-template-columns repeat(auto-fit, minmax(150px, 1fr))
    gap 12px

  .neg-total
    background var(--neg-sup)
    border-radius 24px
    padding 14px 18px

  .neg-total__rotulo
    font-size 12.5px
    color var(--neg-txt2)

  .neg-total__valor
    font-size 20px
    font-weight 500

  .neg-comissoes
    display flex
    flex-direction column
    gap 12px

  .neg-producao
    display flex
    flex-direction column
    gap 12px

  .neg-drawer__topo
    gap 10px

  .neg-drawer__identificacao
    flex 1
    min-width 0

  .neg-drawer__rodape
    gap 6px
    padding 12px 16px

  &.neg-detalhe
    display flex
    flex-direction column
    width 1040px
    max-width 94vw
    height 86vh
    max-height 860px
    overflow hidden

  &.neg-detalhe--cheio
    width 100%
    max-width 100vw
    height 100%
    max-height 100vh
    border-radius 0

  .neg-detalhe__colunas
    flex 1
    min-height 0
    overflow-y auto

  .neg-detalhe__colunas--lado-a-lado
    display grid
    grid-template-columns minmax(0, 1fr) minmax(0, 1fr)
    overflow hidden

    .neg-detalhe__dados,
    .neg-detalhe__historico
      min-height 0
      overflow-y auto

    .neg-detalhe__historico
      border-left 1px solid var(--neg-sup2)

  .neg-detalhe__dados,
  .neg-detalhe__historico
    padding 16px

  .neg-secao
    font-size 14px
    font-weight 500
    color var(--neg-txt)
    margin 20px 0 8px

  .neg-secao--primeira
    margin-top 0

  .neg-linha
    display flex
    align-items center
    justify-content space-between
    gap 12px
    padding 8px 0
    border-bottom 1px solid var(--neg-sup2)
    font-size 14px

  .neg-secao--checklist
    display flex
    align-items baseline
    justify-content space-between
    gap 8px

  .neg-checklist__contagem
    color var(--neg-txt2)
    font-weight 400
    font-size 12.5px

  .neg-checklist
    display flex
    flex-direction column
    gap 4px

  .neg-checklist__item
    display flex
    align-items center
    gap 8px
    background none
    border none
    text-align left
    padding 6px 4px
    font-size 14px
    color var(--neg-txt)
    cursor pointer
    border-radius 8px

  .neg-checklist__item:hover:not(:disabled)
    background var(--neg-sup2)

  .neg-checklist__item--on
    color var(--neg-verde-e)

  .neg-checklist__item:disabled
    cursor not-allowed
    opacity .7

  .neg-timeline
    margin 4px 0 0

    .q-timeline__title
      font-size 14px
      font-weight 500
      line-height 1.4
      margin-bottom 2px

    .q-timeline__subtitle
      font-size 12px
      margin-bottom 2px

    .q-timeline__content
      padding-bottom 18px

  .neg-anotacao-texto
    margin-top 4px
    font-size 14px
    white-space pre-wrap
    overflow-wrap anywhere

  .neg-anotacao-form
    margin 0 0 20px

  .neg-anotacao-form__acoes
    display flex
    justify-content flex-end
    margin-top 8px

  &.neg-modal
    width 560px
    max-width 92vw

  &.neg-modal--estreito
    width 420px

  &.neg-modal--largo
    width 900px

  .neg-modal__titulo
    font-size 20px
    font-weight 500

  .neg-modal__corpo
    display flex
    flex-direction column
    gap 12px

  .neg-modal__mais
    color var(--neg-txt2)

  .neg-linha-extra
    display flex
    align-items center
    gap 8px

  .neg-linha-extra__select
    flex 1
    min-width 0

  .neg-linha-extra__valor
    width 160px
    flex none

  .neg-etapa
    display flex
    align-items center
    gap 10px
    padding 8px 0
    border-bottom 1px solid var(--neg-sup2)

  .neg-etapa__cor
    width 14px
    height 14px
    border-radius 999px
    flex none

  .neg-etapa__nome
    flex 1
    min-width 0
    font-size 14px
    font-weight 500

  .neg-baixa
    display grid
    grid-template-columns 1.4fr 1fr 1.2fr auto
    gap 12px
    align-items start
    padding 12px 0
    border-bottom 1px solid var(--neg-sup2)

  .neg-baixa__identificacao
    min-width 0

  .neg-baixa__total
    display flex
    align-items center
    justify-content space-between
    font-size 16px

@media (max-width: 900px)
  .neg-escopo
    .neg-baixa
      grid-template-columns 1fr
</style>
